import classes from "./PoorResponse.module.css";
export default function PoorResponse({
  getFoodIssue,
  wordCountHandler,
  wordCount,
}) {
  let message = "Kindly tell us the issue in food.";
  return (
    <>
      <div className={classes.poorContainer}>
        <p>Name of the food Item.</p>
        <input
          type="text"
          maxLength="50"
          onChange={(e) => {
            wordCountHandler("name", e.target.value);
            getFoodIssue(e.target.value, "foodNameHavingIssue");
          }}
        />
        <p>{message} </p>
        <p className={classes.wordCount}>{` (${wordCount}) `} </p>

        <textarea
          type="text"
          id="poorDetail"
          maxLength="150"
          onChange={(e) => {
            // console.log(e.target.value);
            wordCountHandler("description", e.target.value);
            getFoodIssue(e.target.value, "foodIssue");
          }}
        />
      </div>
    </>
  );
}
